/**
 * Alertas de ventas para OC (aprobador y creador).
 * Misma lógica que ProductSalesMetrics del Buscador.
 */
export function resolveSalesRisk(ind = {}) {
  const ventas30 = Number(ind.ventas_30_dias) || 0;
  const cantidadVentas = Number(ind.cantidad_ventas) || 0;
  const sinVentas = !ind.fecha_ultima_venta || cantidadVentas === 0;

  return {
    ventas30,
    cantidadVentas,
    sinVentas,
    sinVentas30: !sinVentas && ventas30 === 0,
  };
}
